import api from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';
import { useAdminBadgeCount } from './useAdminBadgeCount';

/**
 * Roles alerted when an arche is awaiting human review. Mirrors the server
 * guard on `GET /admin/plugins/reviews/escalated/count`
 * (`requireAdminOrSupportOrPluginApproverOrIAM`) — if these drift, a reviewer
 * either sees a badge it cannot act on or is never told a review is waiting.
 * Pinned against that guard in tests/architecture/roles-management.test.ts.
 */
export const PLUGIN_REVIEW_ALERT_ROLES = ['admin', 'support', 'plugin_approver'] as const;

/**
 * Number of arches awaiting human review (escalated plugin reviews). Drives the
 * "needs review" alert that surfaces on the user menu, the Dev Console
 * dashboard, and the Plugin Review Queue.
 */
export function usePendingPluginReviewCount(): number {
  return useAdminBadgeCount(
    queryKeys.submissions.escalatedCount(),
    () => api.getEscalatedPluginReviewCount(),
    PLUGIN_REVIEW_ALERT_ROLES,
  );
}
